'use client';

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion';

export interface AccordionSectionItem {
  question: string;
  answer: string;
}

interface AccordionSectionProps {
  heading?: string;
  items: AccordionSectionItem[];
  add_background?: boolean;
  add_bottom_border?: boolean;
}

export default function AccordionSection({
  heading,
  items,
  add_background,
  add_bottom_border,
}: AccordionSectionProps) {
  if (!items || items.length === 0) return null;

  const inner = (
    <div className={`w-full flex flex-col gap-6 ${add_bottom_border ? 'border-b border-gray-200 pb-10' : ''}`}>
      {heading && (
        <h2 className="text-primary-700 text-3xl font-bold">{heading}</h2>
      )}
      <Accordion type="single" collapsible className="w-full">
        {items.map((item, idx) => (
          <AccordionItem key={idx} value={`item-${idx}`}>
            <AccordionTrigger>{item.question}</AccordionTrigger>
            <AccordionContent>
              {item.answer.trim().startsWith('<') ? (
                <div
                  className="prose max-w-none text-gray-800 text-[20px] [&_p]:mb-[18px] [&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:list-disc [&_ul]:pl-6 [&_a]:text-primary-700 [&_a]:underline"
                  dangerouslySetInnerHTML={{ __html: item.answer }}
                />
              ) : (
                <p className="text-gray-800">{item.answer}</p>
              )}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );

  if (add_background) {
    return (
      <section className="w-screen relative left-1/2 right-1/2 -mx-[40vw] bg-[linear-gradient(to_bottom,rgba(237,237,249,0),#DEE5E8)] mb-8 py-8">
        <div className="container max-w-7xl mx-auto px-10 flex flex-col gap-6">
          {inner}
        </div>
      </section>
    );
  }

  return inner;
}
